export const networkResultsMock = [
	{
		id: 'networking-card-onboarding-first',
		title: 'To a recruiter at Google',
		completion: '“Hello! My name is Steven  and I’m a student studying business at the University of Chicago. I saw that you are a recruiter at Google. I recently applied to Google’s PM internship and would love to have a chat with you! Looking forward to hearing from you.”.',
	},
];

export const findEmailMockResults = [
	{
		id: 'cold-email-onboarding-first',
		score: 100,
		email: 'tim@apple.com',
	}, {
		id: 'cold-email-onboarding-first',
		score: 80,
		email: 'timcook@apple.com',
	}, {
		id: 'cold-email-onboarding-first',
		score: 50,
		email: 'tim.cook@apple.com',
	}, {
		id: 'cold-email-onboarding-first',
		score: 5,
		email: 'timmycook@apple.com',
	},
];

export const generateEmailMockResults = 
{
	id: 'generate-cold-email',
	email: 'tim@apple.com',
	subject: 'Experienced Manager Seeking Opportunities to Drive Success',
	body: 'Hi Tim,\n' +
		'\n' +
		'I hope this email finds you well. My name is Jerry, and I am an accomplished manager with a proven track record in leading high-performing teams and driving strategic initiatives. I am reaching out to explore potential opportunities within your organization where I can contribute to achieving outstanding results and fostering growth.\n' +
		'\n' +
		'Looking forward to connecting.\n' +
		'\n' +
		'Best regards,\n' +
		'\nJerry Lee \n https://www.linkedin.com/in/jehakjerrylee/jerry@wonsulting.com',
};

export const resumeResultsMock = [
	{
		id: 'resume-card-onboarding-first',
		completion: 'Led the design of a new customer service process that increased customer satisfaction by 25%.',
	},
	{
		id: 'resume-card-onboarding-second',
		completion: 'Collaborated with cross-functional teams to redesign the company website, resulting in a 20% increase in online sales.',
	},
	{
		id: 'resume-card-onboarding-third',
		completion: 'Created a series of infographics that were shared across social media channels, resulting in a 3x increase in web traffic.',
	},
];
